module.exports = new __parcel__URL__("course_3.a8536d6c.png").toString();